import React from 'react';
import type { ContactMethod } from '../contact.types';
import '../Contact.styles.css';

export const CONTACT_METHODS: readonly ContactMethod[] = [
  {
    icon: 'fas fa-envelope',
    label: 'Email',
    value: 'yashaldiya@gmail.com',
    link: 'mailto:yashaldiya@gmail.com',
  },
  {
    icon: 'fas fa-phone',
    label: 'Phone',
    value: '+91 7976401542',
    link: 'tel:+917976401542',
  },
  {
    icon: 'fab fa-github',
    label: 'GitHub',
    value: 'github.com/yashasvi9199',
    link: 'https://github.com/yashasvi9199',
  },
  {
    icon: 'fas fa-map-marker-alt',
    label: 'Verified Address',
    value: 'Jaipur, Rajasthan 302001, India',
    link: 'https://maps.google.com/?q=Jaipur,+Rajasthan,+India',
  },
];

export const ContactDetails: React.FC<{ isActive?: boolean }> = () => {
  return (
    <div className="contact-info-panel">
      <div>
        <h3 className="info-heading">Contact Yash Haldiya</h3>
        <p className="info-description">
          Open to engineering collaborations, technical inquiries, and professional consulting.
          Reach out through any direct channel below or via the secure message form.
        </p>
      </div>

      <div className="contact-methods-list">
        {CONTACT_METHODS.map((method, index) => (
          <a
            key={index}
            href={method.link}
            className="contact-method-card"
            target={method.link.startsWith('http') ? '_blank' : '_self'}
            rel={method.link.startsWith('http') ? 'noopener noreferrer' : undefined}
          >
            <div className="method-icon-bubble">
              <i className={method.icon} />
            </div>
            <div className="method-details-text">
              <span className="method-label">{method.label}</span>
              <span className="method-value">{method.value}</span>
            </div>
          </a>
        ))}
      </div>

      <div className="social-links-block">
        <h4 className="social-links-heading">Follow Me</h4>
        <div className="social-icons-row">
          <a
            href="https://github.com/yashasvi9199"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-btn"
            aria-label="GitHub Profile"
          >
            <i className="fab fa-github" />
          </a>
          <a
            href="https://www.linkedin.com/in/yash-haldiya/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-btn"
            aria-label="LinkedIn Profile"
          >
            <i className="fab fa-linkedin" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
